// extracted by mini-css-extract-plugin
module.exports = {"root":"Useful_root__0EZRF","root_title":"Useful_root_title__hKQ1j","root_items":"Useful_root_items__u_4_Z","root_items_item":"Useful_root_items_item__bQt4J"};